/* eslint-disable no-param-reassign */
/* eslint-disable */
import React, { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';

import * as actions from '../action';

function VerifyReceipt({
  seniorCitizenInfo,
  id,
  createInput,
  formData,
  // assessReceipt,
  showSeniorCitizen,
}) {
  const setModal = useContext(ModalContext);
  const [showRemarks, setShowRemarks] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!showRemarks) {
      delete formData.remarks;
      formData = {
        ...formData,
        is_approve: 1,
      };
    } else {
      formData = {
        ...formData,
        is_approve: 0,
      };
    }

    // assessReceipt(id, formData, () => {
    //   setModal({ isOpen: false });
    //   showSeniorCitizen(id);
    // });
  };

  // const remarks =
  //   _.get(seniorCitizenInfo, 'attributes.payment_receipt_url_remarks') || '';

  // const approved =
  //   _.get(seniorCitizenInfo, 'attributes.is_approved_payment_receipt') || '';

  
  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12">
          {/* {approved && (
            <div className="alert alert-success" role="alert">
              {remarks}
            </div>
          )}
          {!approved && remarks && (
            <div className="alert alert-danger" role="alert">
              {remarks}
            </div>
          )}
          {!remarks && ( */}
            <div className="alert alert-info" role="alert">
              <span>Amount: </span>{ _.get(seniorCitizenInfo, 'attributes.amount') || '' }
            </div>
          {/* )} */}
        </div>

        <div className="col-12">
          {/* <img
            className="w-100 border"
            src={
              _.get(seniorCitizenInfo, 'attributes.payment_receipt_url')
                ? _.get(seniorCitizenInfo, 'attributes.payment_receipt_url')
                : ImagePlaceholder
            }
            alt=""
          />*/}
        </div> 
      </div>
      {!_.get(seniorCitizenInfo, 'attributes.is_approved_payment_receipt') && (
        <form onSubmit={handleSubmit} className="pt-2">
          {showRemarks && (
            <div className="row">
              <div className="col-12 form-group">
                {createInput({ key: 'remarks', label: 'Remarks:' })}
              </div>
            </div>
          )}
          <div className="row d-flex justify-content-center pt-2">
            {showRemarks ? (
              <div>
                <button
                  type="button"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-1"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowRemarks(false);
                  }}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-danger">
                  Reject
                </button>
              </div>
            ) : (
              <div>
                <button
                  disabled={
                    !_.get(seniorCitizenInfo, 'attributes.amount')
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary  mr-1"
                >
                  Approve
                </button>
                <button
                  disabled={
                    !_.get(seniorCitizenInfo, 'attributes.amount')
                  }
                  type="button"
                  className="btn btn-danger"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowRemarks(true);
                  }}
                >
                  Reject
                </button>
              </div>
            )}
          </div>
        </form>
      )}
    </Modal.Body>
  );
}

VerifyReceipt.propTypes = {
  // assessReceipt: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  
  showSeniorCitizen: PropTypes.instanceOf(Function).isRequired,
  seniorCitizenInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(VerifyReceipt);

// TODO: CHANGE VERIFY RECEIPT NAME LATER
